import { useRef, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { useAuth } from "../../../../contexts/AuthContext";

import {
  alpha,
  Avatar,
  Box,
  Button,
  Divider,
  Hidden,
  lighten,
  Popover,
  Typography
} from '@mui/material';

import { styled } from '@mui/material/styles';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import StorefrontIcon from '@mui/icons-material/Storefront';

const UserBoxButton = styled(Button)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};
`
);

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.primary.main};
        display: block;
`
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
        color: ${lighten(theme.palette.primary.main, 0.4)}
`
);

function HeaderUserbox() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const fullName = user ? `${user.nombre}` : "";
  const formatRol = (codigo?: string) =>
    (codigo ?? '').split('_').map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');
  const rolName = user ? formatRol(user.rol?.nombre) : "";
  const sucursalNombre = user?.sucursal?.nombre;
  const puedeCambiarSucursal = (user?.sucursales?.length ?? 0) > 1;

  const handleCambiarSucursal = () => {
    setOpen(false);
    navigate("/seleccionar-sucursal");
  };

  const avatar = {
    ruta: `${process.env.PUBLIC_URL}/static/images/avatars/1.jpg`,
  };

  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  return (
    <>
      <UserBoxButton
        color="primary"
        ref={ref}
        onClick={handleOpen}
        sx={(theme) => ({
          backgroundColor: alpha(theme.palette.primary.main, 0.1),
          borderRadius: theme.general.borderRadiusLg,
          '&:hover': {
            backgroundColor: theme.palette.primary.light
          }
        })}
      >
        <Avatar variant="rounded" alt={fullName} src={avatar.ruta} />
        <Hidden mdDown>
          <UserBoxText>
            <UserBoxLabel variant="body1">{fullName}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {rolName}
            </UserBoxDescription>
          </UserBoxText>
        </Hidden>
        <Hidden smDown>
          <ExpandMoreTwoToneIcon sx={{ ml: 1 }} />
        </Hidden>
      </UserBoxButton>
      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuUserBox sx={{ minWidth: 210 }} display="flex">
          <Avatar variant="rounded" alt={fullName} src={avatar.ruta} />
          <UserBoxText>
            <UserBoxLabel variant="body1">{fullName}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {sucursalNombre ? `${rolName} · ${sucursalNombre}` : rolName}
            </UserBoxDescription>
          </UserBoxText>
        </MenuUserBox>
        <Divider sx={{ mb: 0 }} />
        {/* <List sx={{ p: 1 }} component="nav">
          <ListItem button to="/management/profile/details" component={NavLink}>
            <AccountBoxTwoToneIcon fontSize="small" />
            <ListItemText primary="My Profile" />
          </ListItem>
          <ListItem button to="/dashboards/messenger" component={NavLink}>
            <InboxTwoToneIcon fontSize="small" />
            <ListItemText primary="Messenger" />
          </ListItem>
          <ListItem
            button
            to="/management/profile/settings"
            component={NavLink}
          >
            <AccountTreeTwoToneIcon fontSize="small" />
            <ListItemText primary="Account Settings" />
          </ListItem>
        </List> */}
        <Divider />
        <Box sx={{ m: 1, display: "flex", flexDirection: "column", gap: 1 }}>
          {puedeCambiarSucursal && (
            <Button color="secondary" fullWidth onClick={handleCambiarSucursal} startIcon={<StorefrontIcon />}>
              Cambiar sucursal
            </Button>
          )}
          <Button color="primary" fullWidth onClick={logout}>
            <LockOpenTwoToneIcon sx={{ mr: 1 }} />
            Sign out
          </Button>
        </Box>
      </Popover>
    </>
  );
}

export default HeaderUserbox;
